export default __webpack_public_path__ + "static/media/mn.6f7b178c.svg";